import React, { useState } from 'react';

const productsData = [
  {
    id: 1,
    name: '法式经典草莓蛋糕',
    category: 'classic',
    description: '新鲜草莓与香草奶油完美结合，入口即化',
    price: 298,
    originalPrice: 358,
    badge: '热销',
    image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=600&q=80',
    tag: '经典'
  },
  {
    id: 2,
    name: '皇家比利时巧克力',
    category: 'chocolate',
    description: '72%纯度黑巧克力，浓郁丝滑',
    price: 358,
    originalPrice: 428,
    badge: '新品',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600&q=80',
    tag: '巧克力'
  },
  {
    id: 3,
    name: '清新水果塔',
    category: 'fruit',
    description: '季节水果与卡仕达酱的清新搭配',
    price: 228,
    originalPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=600&q=80',
    tag: '水果'
  },
  {
    id: 4,
    name: '北海道芝士蛋糕',
    category: 'cheese',
    description: '日式轻芝士，绵密细腻入口即化',
    price: 268,
    originalPrice: 318,
    badge: '招牌',
    image: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=600&q=80',
    tag: '芝士'
  },
  {
    id: 5,
    name: '提拉米苏',
    category: 'classic',
    description: '意大利经典，咖啡与马斯卡彭的邂逅',
    price: 288,
    originalPrice: null,
    badge: null,
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600&q=80',
    tag: '经典'
  },
  {
    id: 6,
    name: '榛子巧克力蛋糕',
    category: 'chocolate',
    description: '香脆榛子与丝滑巧克力的双重享受',
    price: 328,
    originalPrice: 398,
    badge: '限定',
    image: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=600&q=80',
    tag: '巧克力'
  },
  {
    id: 7,
    name: '芒果千层蛋糕',
    category: 'fruit',
    description: '新鲜芒果与层层班戟的完美结合',
    price: 298,
    originalPrice: null,
    badge: '新品',
    image: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=600&q=80',
    tag: '水果'
  },
  {
    id: 8,
    name: '双重芝士蛋糕',
    category: 'cheese',
    description: '轻芝士+重芝士的双重风味',
    price: 298,
    originalPrice: 358,
    badge: null,
    image: 'https://images.unsplash.com/photo-1524351199678-941a58a3df50?w=600&q=80',
    tag: '芝士'
  }
];

function Products({ onOpenQuickView }) {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { key: 'all', label: '全部' },
    { key: 'classic', label: '经典系列' },
    { key: 'fruit', label: '水果系列' },
    { key: 'chocolate', label: '巧克力系列' },
    { key: 'cheese', label: '芝士系列' }
  ];

  const filteredProducts = activeFilter === 'all' 
    ? productsData 
    : productsData.filter(p => 
        p.category === activeFilter || 
        p.tag.toLowerCase() === activeFilter
      );

  const handleQuickView = (product) => {
    onOpenQuickView(product);
  };

  const ProductCard = ({ product }) => (
    <div className="product-card" data-id={product.id}>
      <div className="product-image">
        <img 
          src={product.image} 
          alt={product.name} 
          className="product-img"
          onError={(e) => {
            e.target.src = 'data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><text y=%22.9em%22 font-size=%2290%22>🍰</text></svg>';
          }}
        />
        {product.badge && <span className="product-badge">{product.badge}</span>}
        <div className="product-actions">
          <button 
            className="product-action-btn quick-view-btn" 
            data-id={product.id}
            onClick={() => handleQuickView(product)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          </button>
          <button className="product-action-btn wishlist-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
        </div>
      </div>
      <div className="product-info">
        <span className="product-category">{product.tag}</span>
        <h3 className="product-name">{product.name}</h3>
        <p className="product-desc">{product.description}</p>
        <div className="product-footer">
          <div className="product-price">
            <span className="price-current">¥{product.price}</span>
            {product.originalPrice && (
              <span className="price-original">¥{product.originalPrice}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section className="products" id="cakes">
      <div className="container">
        <div className="section-header">
          <span className="section-label">人气推荐</span>
          <h2 className="section-title">今日特供</h2>
        </div>
        <div className="products-filter">
          {filters.map(filter => (
            <button 
              key={filter.key}
              className={`filter-btn ${activeFilter === filter.key ? 'active' : ''}`}
              data-filter={filter.key}
              onClick={() => setActiveFilter(filter.key)}
            >
              {filter.label}
            </button>
          ))}
        </div>
        <div className="products-grid">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        <div className="products-more">
          <a href="#" className="btn btn-outline">查看更多</a>
        </div>
      </div>
    </section>
  );
}

export default Products;
